export default __webpack_public_path__ + "b0a78d5.png";